import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const notificationsRoutes = [
  {
    path: '/event-notification-settings',
    name: Routes.EventNotificationSettings,
    component: () => import('@/pages/contexts/portal/event-notification-settings/Index.vue'),
    meta: {
      pageTitle: 'Event Notifications',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_EVENT_NOTIFICATIONS,
    },
  },
]
